
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'
import { HttpAxiosError, ApiResponse } from '@/plugins/http'

/** お知らせ管理：検索型 */
export type NotificationSearchQuery = {
  title?: string
}

/** お知らせ管理：ページネーション型 */
export type NotificationPagination = {
  pagination: Pagination
  responses: NotificationItem[]
}

/** お知らせ管理：一覧表示型 */
export type NotificationItem = {
  id: number
  title: string
  startedAt: string
  endedAt: string
  createdAt: string
  updatedAt: string
}

@Component
export default class NotificationApis extends Vue {
  /**
   * お知らせ管理：一覧取得
   */
  protected async searchNotificationItemsApi(
    notificationSearchQuery: NotificationSearchQuery,
    pageNumber: number
  ): Promise<NotificationPagination> {
    try {
      const { data }: { data: NotificationPagination } = await Vue.prototype.$http.httpWithToken.get(
        `/v1/notifications/?page=${pageNumber}`,
        {
          params: notificationSearchQuery,
        }
      )
      Vue.prototype.$logger.log(data)

      return data
    } catch (_error: any) {
      return {
        pagination: {
          page: 0,
          limit: 0,
          totalCount: 0,
        },
        responses: [],
      }
    }
  }

  /**
   * お知らせ管理：削除
   */
  protected async deleteNotificationItemApi(
    notificationId: number,
    onSuccess: () => Promise<void>,
    onError: (error: ApiResponse | null) => Promise<void>
  ): Promise<void> {
    await Vue.prototype.$http.httpWithToken
      .delete(`/v1/notifications/${notificationId}`)
      .then(async () => {
        await onSuccess()
      })
      .catch(async (error: HttpAxiosError) => {
        if (error.response) {
          await onError(error.response.data instanceof Blob ? null : error.response.data)
        } else {
          await onError(null)
        }
      })
  }
}
